(function (angular, parseInt) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyPricingPage", [
    "$parse",
    "Dealer",
    "UrlParser",
    "PricingPageAnalyticsService",
    "$location",
    "Location",
    "ModalService",
    "DebugLogger",
    "GetPseudoElementContent",
    "Tfy",
    "$rootScope",
    "Wishlist",
    function (
      $parse,
      Dealer,
      UrlParser,
      PricingPageAnalyticsService,
      $location,
      Location,
      ModalService,
      DebugLogger,
      GetPseudoElementContent,
      Tfy,
      $rootScope,
      Wishlist,
    ) {
      function handleReject(error) {
        DebugLogger.log("tyPricingPage", error);
      }

      var controller = [
        "$scope",
        "$timeout",
        "$element",
        "$q",
        "Range",
        "VehicleService",
        "$attrs",
        function (
          $scope,
          $timeout,
          $element,
          $q,
          Range,
          VehicleService,
          $attrs
        ) {
          var ctl = this;
          var materialCodeDeferred;
          var initialSelection;

          var isFirstLoad = true;

          var vehicleFeaturesDefault = {
            paint: { label: "Paint", value: "" },
            transmission: { label: "Transmission", value: "" },
            drivetrain: { label: "Drivetrain", value: "" },
            bodyType: { label: "Body Type", value: "" },
            engineType: { label: "Engine", value: "" },
            extras: { label: "Extras", value: "" },
          };

          var driveTrainMap = {
            front: "FWD",
            rear: "RWD",
          };

          var transmissionMap = {
            cvt: "CVT Automatic",
          };

          $scope.pricingPage = {
            loading: false,
            orderAndCollectLoading: true,
            vehicleFeatures: {},
            gradeName: "",
            modelName: "",
            displayFinanceOptions: false,
            materialCodePaintLoaded: null,
          };

          var ctaLoading = {};

          $scope.pricingPage.onDidCtaLoadingInitOrChange = function (
            ctaId,
            loading
          ) {
            ctaLoading[ctaId] = loading;

            var isLoading = Object.keys(ctaLoading).reduce(function (acc, key) {
              return acc || ctaLoading[key];
            }, false);

            $scope.pricingPage.orderAndCollectLoading = isLoading;
          };

          ctl.urlWithCampaignTracking = function (
            url,
            materialCode,
            utmMedium,
            utmTerm
          ) {
            var newAttributes = {
              m: materialCode,
              tpr_source: 4,
              utm_source: "toyota_com_au",
              utm_medium: utmMedium,
              utm_campaign: "dealer_integration_finance_tpr",
              utm_term: utmTerm,
              utm_content: location.href,
            };
            return UrlParser.overrideUrlQueryStringFromMap(url, newAttributes);
          };

          function updateHasDealer() {
            var dealer = Dealer.getSaved();
            $scope.dealer = dealer;
            $scope.hasDealer = dealer && dealer.branchCode;
            $scope.hasValidOrderAndCollectUrl =
              dealer &&
              dealer.orderAndCollectFlag &&
              dealer.orderAndCollectURL !== null &&
              dealer.orderAndCollectURL.length > 0;
            var orderAndCollectURL =
              dealer.orderAndCollectURL + "/finance/get-tpr";
            $scope.tprURL = ctl.urlWithCampaignTracking(
              orderAndCollectURL,
              $scope.materialCode,
              "buildandprice",
              "toyota_personal_repayments"
            );
            accessFinanceCalculatorVisibilityCheck();
          }

          function init() {
            var variantOptions = angular.fromJson($attrs.variantOptions);
            var gradesList = angular.fromJson($attrs.gradesList);

            if (!(gradesList && gradesList.length)) {
              DebugLogger.log("tyPricingPage", "gradesList is empty");
              return;
            }

            var hasVariantOptions =
              variantOptions &&
              Object.keys(variantOptions).reduce(function (acc, key) {
                return acc.concat(variantOptions[key]);
              }, []).length;

            if (!hasVariantOptions) {
              DebugLogger.log("tyPricingPage", "variantOptions is empty");
              return;
            }

            $scope.pricingPage.displayFinanceOptions =
              $attrs.displayFinanceOptions === "True";
            initialiseInitialSelection();

            ctl.grades = gradesList;
            Range.setVariantOptionsInCache(variantOptions);
            Range.ingestGradesList(gradesList);

            $scope.$on("did-location-change-dealers-load-end", function () {
              updateHasDealer();
            });

            $scope.$on("dealer-saved-did-change", function () {
              updateHasDealer();
            });

            $scope.$on("modal-close", function (event, modalId) {
              modalClose(event, modalId);
            });

            // capture emit event for modal exit.
            $scope.$on("modal-exit", function (event, modalId) {
              modalClose(event, modalId);
            });
          }

          function modalClose(_event, modalId) {
            if (modalId !== "change-location") {
              return;
            }

            var location = Location.get();

            if (!hasSelectedPostCode(location)) {
              return;
            }

            // Save location
            var savedDealer = Dealer.getSaved();

            var postCode =
              location.postcode !== null && location.postcode.length > 0
                ? location.postcode
                : "not selected";
            var suburb =
              location.suburb !== null && location.suburb.length > 0
                ? location.suburb
                : "not selected";
            var selectedLocation =
              postCode !== "not selected" && suburb !== "not selected"
                ? suburb + " " + postCode
                : "not selected";
            var dealerName =
              savedDealer && savedDealer.name && savedDealer.name !== null
                ? savedDealer.name
                : "not selected";

            PricingPageAnalyticsService.triggerAnalytics("gaClick", {
              eventCategory: "pricing",
              eventAction: "set location",
              eventLabel:
                selectedLocation !== "not selected"
                  ? selectedLocation
                  : "setPostcode",
              dealerName: dealerName,
              dealerSuburb: suburb,
              selectedLocation: selectedLocation,
            });

            if (
              savedDealer &&
              savedDealer !== null &&
              savedDealer.name !== null &&
              savedDealer.name.length > 0
            ) {
              // save Dealer
              PricingPageAnalyticsService.triggerAnalytics("gaClick", {
                eventCategory: "pricing",
                eventAction: "set location",
                eventLabel: savedDealer.name,
                selectedLocation: savedDealer.city + " " + savedDealer.postCode, // add null checking
                dealerName: savedDealer.name,
                dealerSuburb: savedDealer.city,
              });
            }
          }

          function hasSelectedPostCode(location) {
            return (
              location &&
              location !== null &&
              location.postcode &&
              location.postcode !== null &&
              location.postcode.length > 0
            );
          }

          function initialiseInitialSelection() {
            initialSelection = angular.fromJson($attrs.initialSelection);

            if (initialSelection) {
              ctl.initialSelection = initialSelection;
            } else {
              ctl.initialSelection = {};
            }
          }

          $scope.$watchGroup(
            [
              "driveawayPrice.loading",
              "pricingImage.loading",
              "dealerInventory.loading",
              "pricingPage.loading",
            ],
            function () {
              var shouldShowLoadingOverlay =
                !!$scope.driveawayPrice?.loading ||
                !!$scope.pricingImage?.loading ||
                !!$scope.dealerInventory?.loading ||
                !!$scope.pricingPage?.loading;

              if (shouldShowLoadingOverlay) {
                showLoadingOverlay();
              } else {
                hideLoadingOverlay();
              }
            },
            true
          );

          $scope.$watch(
            "materialCode",
            function (newValue, oldValue) {
              if (
                typeof $scope.materialCode !== "undefined" &&
                newValue !== oldValue
              ) {
                VehicleService.setCurrentVehicleByMaterialCode(
                  $scope.materialCode
                ).then(function (vehicle) {
                  parseVehicleFeatures(vehicle);
                });
                updateHasDealer();
              }
            },
            true
          );

          $scope.$on("GeoPostCode", function (event, postcode) {
            VehicleService.setVehiclePricingParamsPostcode(postcode);
            hideLoadingOverlay();
          });

          function parseVehicleFeatures(vehicle) {
            $scope.pricingPage.vehicleFeatures = vehicleFeaturesDefault;

            $scope.pricingPage.vehicleFeatures.paint.value = vehicle.paint
              .IsPremium
              ? "Premium"
              : "Standard";
            $scope.pricingPage.vehicleFeatures.transmission.value =
              translateTransmission(vehicle.variant.transmission);
            $scope.pricingPage.vehicleFeatures.drivetrain.value =
              translateDriveTrain(vehicle.variant.drivetrain);
            $scope.pricingPage.vehicleFeatures.bodyType.value =
              vehicle.variant.cab;
            $scope.pricingPage.vehicleFeatures.engineType.value =
              vehicle.variant.engineType.replace(/turbo/gi, "T");

            if (vehicle.variant.optionPack.length > 0) {
              $scope.pricingPage.vehicleFeatures.extras.value = "1 selected";
            } else {
              $scope.pricingPage.vehicleFeatures.extras.value = "";
            }

            $scope.pricingPage.vehicleConfigurationLoading = false;
          }

          function translateDriveTrain(driveTrain) {
            return driveTrainMap[driveTrain.toLowerCase()] || driveTrain;
          }

          function translateTransmission(transmission) {
            return transmissionMap[transmission.toLowerCase()] || transmission;
          }

          function setFirstLoadOverlayVisibility(isVisible) {
            DebugLogger.log(
              "tyPricingPage",
              'setFirstLoadOverlayVisibility("' + isVisible + '")'
            );

            var $fullscreenLoader = angular
              .element($element)
              .find("[data-ty-pricing-full-screen-loader]");

            if (!$fullscreenLoader.length) {
              DebugLogger.log("tyPricingPage", "fullscreen loader element not found");
              return;
            }

            $fullscreenLoader
              .toggleClass("is-visible", isVisible)
              .toggleClass("is-hidden", !isVisible);

            if (!isVisible) {
              var timeoutMs = parseInt(
                GetPseudoElementContent($fullscreenLoader[0], "before")
              );
              DebugLogger.log(
                "tyPricingPage",
                "Will hide $fullscreenLoader in " + timeoutMs + "ms"
              );

              $timeout(function () {
                $fullscreenLoader.css("display", "none");
                isFirstLoad = false;
                DebugLogger.log(
                  "tyPricingPage",
                  "Did hide $fullscreenLoader, isFirstLoad set to false so it never shows again"
                );
              }, timeoutMs);
            } else {
              $fullscreenLoader.css("display", "");
              DebugLogger.log("tyPricingPage", "Did show $fullscreenLoader");
            }
          }

          function showLoadingOverlay() {
            DebugLogger.log("tyPricingPage", "showLoadingOverlay()");
            setFirstLoadOverlayVisibility(isFirstLoad);
            $scope.pricingPage.showLoadingOverlay = !isFirstLoad;

            $scope.specialOffer.isHot = false;
            $scope.specialOffer.isCool = false;
            $scope.financeOptions.variables.isCampaign = false;
          }

          function hideLoadingOverlay() {
            DebugLogger.log("tyPricingPage", "hideLoadingOverlay()");
            setFirstLoadOverlayVisibility(false);
            $scope.pricingPage.showLoadingOverlay = false;

            $timeout(function () {
              ctl.onPricingPageLoaded($scope);
            });
          }

          function accessFinanceCalculatorVisibilityCheck() {
            const pricingAccessFinanceCalculator = document.querySelector(
              ".ty_pricing_access_finance_calculator"
            );
            if (pricingAccessFinanceCalculator) {
              const hideDriveAwayPriceFlag =
                !!$scope.driveawayPrice?.hideDriveawayPrice ||
                !!$scope.driveawayPrice?.showError() ||
                !Dealer.getSaved()?.branchCode;

              if (hideDriveAwayPriceFlag) {
                pricingAccessFinanceCalculator.classList.remove("show");
              } else {
                pricingAccessFinanceCalculator.classList.add("show");
              }
            }
          }

          function broadcastBaseMaterialCode() {
            if (materialCodeDeferred && !materialCodeDeferred.promise.done) {
              materialCodeDeferred.reject(
                "Pricing page - material code selection changed mid-load"
              );
            }

            materialCodeDeferred = $q.defer();
            var promise = materialCodeDeferred.promise;
            promise.done = false;
            promise
              .then(function () {
                promise.done = true;
              })
              .catch(handleReject);

            $scope.$broadcast(
              "pricing-page-material-code",
              materialCodeDeferred.promise
            );
          }

          $scope.$on(
            "pricing-page-material-code",
            function (e, materialCodePromise) {
              materialCodePromise
                .then(function (pricingPageMaterialCodeObject) {
                  DebugLogger.log(
                    "tyPricingPage",
                    "pricing-page-material-code-paint-loaded"
                  );
                  $scope.pricingPage.materialCodePaintLoaded =
                    pricingPageMaterialCodeObject.materialCode;
                  $rootScope.$broadcast(
                    "pricing-page-material-code-paint-loaded",
                    $scope.pricingPage.materialCodePaintLoaded
                  );
                  Wishlist.clearPendingAddToWishlist();
                  Wishlist.clearLastAddedToWishlist();
                })
                .catch(handleReject);
            }
          );

          function updateAndResolveBaseMaterialCodeDeferred(materialCode) {
            if (materialCode) {
              $scope.materialCode = materialCode;
              materialCodeDeferred.resolve({
                materialCode: $scope.materialCode,
              });
            }
          }

          ctl.$onInit = init;

          ctl.setGrade = function (gradeId) {
            $scope.$broadcast("grade-changed", gradeId);
            $scope.pricingPage.loading = true;
            var gradeInfo = Range.getGradesList().find(function (grade) {
              return grade.gradeId === gradeId;
            });
            var containsOptionPacks = findOptionPacks();
            var specialOfferDetails = findSpecialOffers();

            if (!gradeInfo) {
              return;
            }

            var gradeData = {
              id: gradeId,
              name: gradeInfo.name,
              baseVariantId: gradeInfo.baseVariantId,
              containsRoofPaints: gradeInfo.containsRoofPaints,
              containsCabChassis: gradeInfo.containsCabChassis,
              containsOptionPacks: containsOptionPacks,
              hasSpecialOffers: specialOfferDetails.hasSpecialOffers,
              vehicleModel: angular.extend(
                gradeInfo.vehicleModel,
                specialOfferDetails.vehicleModel
              ),
            };

            $scope.pricingPage.gradeName = gradeInfo.name;
            $scope.pricingPage.modelName = gradeInfo.vehicleModel.Name;
            $scope.driveawayPrice.hideDriveawayPrice =
              gradeInfo.hideDriveawayPrice;
            $scope.driveawayPrice.showIndicativeDriveawayText =
              gradeInfo.showIndicativeDriveawayText;
            $scope.driveawayPrice.indicativeDriveawayText =
              gradeInfo.indicativeDriveawayText;

            accessFinanceCalculatorVisibilityCheck();
            emitGradeChangedEvent(gradeData);
          };

          function findOptionPacks() {
            return Range.getGradesList().reduce(function (accum, grade) {
              return accum || grade.containsOptionPacks;
            }, false);
          }

          function findSpecialOffers() {
            var grade = Range.getGradesList().find(function (grade) {
              return (
                grade.hasSpecialOffers &&
                !!grade.vehicleModel.Title &&
                !!grade.vehicleModel.Name
              );
            });

            if (grade) {
              return {
                hasSpecialOffers: true,
                vehicleModel: {
                  specialOfferLinkQuery: grade.vehicleModel.Name,
                },
              };
            }

            return {
              hasSpecialOffers: false,
              vehicleModel: {},
            };
          }

          function emitGradeChangedEvent(gradeData) {
            var validVariantIdsForCurrentGrade = {
              grade: gradeData,
              source: "grade",
            };

            ctl.validVariantIdsForCurrentGrade = validVariantIdsForCurrentGrade;
          }

          ctl.setVariantIds = function (pricingPageVariantIdsChangedData) {
            $scope.pricingPage.loading = true;
            $scope.pricingPage.vehicleConfigurationLoading = true;
            $scope.pricingPage.variantName = Range.getVariantByIdFromCache(
              pricingPageVariantIdsChangedData.variantIds[0]
            ).name;
            $scope.$broadcast(
              "variant-changed",
              pricingPageVariantIdsChangedData
            );
          };

          ctl.setTrimIds = function (pricingPageTrimChangedData) {
            $scope.$broadcast("trims-changed", pricingPageTrimChangedData);
          };

          ctl.setPaint = function (promise) {
            $scope.$broadcast("paint-changed", promise);

            broadcastBaseMaterialCode();
            $scope.pricingPage.loading = true;
            $scope.pricingPage.vehicleConfigurationLoading = true;

            promise
              .then(function (pricingPagePaintChangedData) {
                $scope.pricingPage.loading = false;
                updateAndResolveBaseMaterialCodeDeferred(
                  pricingPagePaintChangedData.materialCode
                );
              })
              .catch(handleReject);
          };

          ctl.$onInit = init;

          ctl.analytics = function (action, label) {
            PricingPageAnalyticsService.triggerAnalytics("gaClick", {
              eventCategory: "pricing",
              eventAction: action,
              eventLabel: label,
            });
          };

          ctl.getFinanceSetting = function () {
            return PricingPageAnalyticsService.getFinanceSetting();
          };

          ctl.pushToDataLayer = function (action, label) {
            PricingPageAnalyticsService.pushToDataLayer({
              event: "gaClick",
              eventCategory: "pricing",
              eventAction: action,
              eventLabel: label,
            });
          };

          $scope.pricingPage.triggerLocationAnalyticsClick = function () {
            PricingPageAnalyticsService.triggerAnalytics("gaClick", {
              eventCategory: "pricing",
              eventAction: "link",
              eventLabel: "set location",
            });
          };

          function showFinanceOptionsWhenDataAvailable(dataAlreadyLoaded) {
            if (!dataAlreadyLoaded) {
              var unbind = $scope.$on(
                "pricing-page-driveaway-price-loaded",
                function () {
                  $scope.driveawayPrice.repaint();
                  $scope.financeOptions.triggerFinanceOptionsFinanceAnalytics();
                  $scope.financeOptions.showFinanceOptionsFinance(false);
                  unbind();
                }
              );
              return;
            }

            $scope.financeOptions.triggerFinanceOptionsFinanceAnalytics();
            $scope.financeOptions.showFinanceOptionsFinance(true);
          }

          ctl.showFinanceTabWhenFinanceQueryStringIsPresent = function () {
            var queryStringObject = $location.search();

            if (queryStringObject.ft !== "1") {
              return;
            }

            var postcode = Location.get().postcode;

            if (!postcode) {
              ModalService.openModal("change-location");

              var unbindGeoPostcode = $scope.$on("GeoPostCode", function () {
                showFinanceOptionsWhenDataAvailable(false);
                unbindGeoPostcode();
              });

              return;
            }

            showFinanceOptionsWhenDataAvailable(true);
          };

          $scope.redirectToDealerPage = function (
            label = "CALCULATE YOUR REPAYMENTS WITH TOYOTA ACCESS"
          ) {
            var savedDealer = Dealer.getSaved();

            PricingPageAnalyticsService.triggerAnalytics("gaClick", {
              eventCategory: "pricing",
              eventAction: "link",
              eventLabel: label,
              selectedLocation: savedDealer.city + " " + savedDealer.postCode, // add null checking
              dealerName: savedDealer.name,
              dealerSuburb: savedDealer.city,
              tprJourney: "tmca pricing page",
            });

            window.open($scope.tprURL, "_blank");
          };

          $scope.redirectToDealerFslPage = function (
            label = "GET A FULL-SERVICE LEASE QUOTE"
          ) {
            var orderAndCollectURL = $scope.dealer?.orderAndCollectURL;
            var savedDealer = Dealer.getSaved();

            if (!orderAndCollectURL || !$scope.materialCode) {
              DebugLogger.log("tyPricingPage", "Cannot redirect to FSL page - missing required parameters");
              return;
            }

            var baseUrl = orderAndCollectURL + "/finance/full-service-lease/quote";
            var urlParams = {
              m: $scope.materialCode,
              fsl_source: 4,
              utm_source: "toyota_com_au",
              utm_medium: "buildandprice",
              utm_campaign: "dealer_integration_finance_fsl"
            };

            var fslQuoteURL = UrlParser.overrideUrlQueryStringFromMap(baseUrl, urlParams);

            PricingPageAnalyticsService.triggerAnalytics("gaClick", {
              eventCategory: "pricing",
              eventAction: "link",
              eventLabel: label,
              selectedLocation: savedDealer.city + " " + savedDealer.postCode,
              dealerName: savedDealer.name,
              dealerSuburb: savedDealer.city,
              tprJourney: "tmca pricing page",
            });

            window.open(fslQuoteURL, "_blank");
          }

          $scope.openTPR = function (label) {
            PricingPageAnalyticsService.pushToDataLayer({
              event: 'click_secondary_interaction',
              click_text: label,
              click_type: 'Button',
              link_url: $scope.tprURL,
              module_name: null,
              element_name: null
            })

            window.open($scope.tprURL, "_blank");
          }

          $scope.redirectToGenericDealerPage = function () {
            var savedDealer = Dealer.getSaved();
            PricingPageAnalyticsService.triggerAnalytics("gaClick", {
              eventCategory: "pricing",
              eventAction: "link",
              eventLabel: "LOCAL DEALER",
              selectedLocation: savedDealer.city + " " + savedDealer.postCode, // add null checking
              dealerName: savedDealer.name,
              dealerSuburb: savedDealer.city,
              tprJourney: "tmca pricing page",
            });
            var dealer = Dealer.getSaved();

            window.open(
              "http://" + dealer.webSite.replace("http://", ""),
              "_blank"
            );
          };

          const hasDriveawayPriceIssues = () => $scope.driveawayPrice?.hideDriveawayPrice || $scope.driveawayPrice?.showError();
    
          $scope.determineFinanceOptionsScenario = function () {
            if(!$scope.pricingPage || !$scope.financeCalculator || !$scope.pricingPage?.displayFinanceOptions) return null;
            
            // Scenario 1: Show select a dealer text when no dealer is selected
            if(!$scope.hasDealer) return 'selectDealer';
          
            if(!$scope.financeCalculator?.isFinanceCalculationProcessed) return null;

            // Scenario 2: Show dealer scenario only if ALL conditions are met
            if (!$scope.financeCalculator.hasError &&
              $scope.dealer?.webSite &&
              !hasDriveawayPriceIssues() &&
              $scope.hasValidOrderAndCollectUrl) {
              return 'dealer';
            }

            // All other scenarios
            return 'generic';           
          };

          ctl.handleError = function (error) {
            if (isFirstLoad) {
              var $fullPageError = angular.element(
                $attrs.tyPricingPageErrorFullPageSelector
              );
              $fullPageError
                .addClass($attrs.tyPricingPageErrorFullPageAddCssClass)
                .css("display", "");
            } else {
              ModalService.openModal($attrs.tyPricingPageErrorModalId);
            }

            DebugLogger.log("tyPricingPage", "handleError: " + error);
          };
        },
      ];

      var link = function ($scope, $element, $attrs) {
        $scope.$broadcast("pricingpage-on-link-trigger", {});
        $scope.tyPricingPage.onPricingPageLoaded = $parse(
          $attrs.tyPricingPageOnLoaded
        );
      };

      return {
        scope: true,
        restrict: "A",
        controller: controller,
        controllerAs: "tyPricingPage",
        link: link,
      };
    },
  ]);
})(window.angular, window.parseInt);
